const paths = {
  addresses: '/relation/addresses',
  api: 'api/v1',
  companies: '/relation/companies',
  countries: '/geography/countries',
  customers: '/relation/customers',
  orderCollections: '/order/order-collections',
  orders: '/order/orders',
  postcodeSuggestion: '/postcode/suggestion',
  changePassword: '/me/change-password',
};

export default paths;
